//
//
//
//
//
//

export default {
  props: {
    ecomProduct: { type: Object, required: true }
  },
  computed: {
    price () { return parseFloat(this.ecomProduct.price) }
  },
  methods: {
    async addToCart (additionalProductSKU = null) {
      const queryOptions = {}
      if (additionalProductSKU) queryOptions.related_product_sku = additionalProductSKU
      const success = await this.$store.dispatch('cart/ADD_TO_CART', [{
        ...queryOptions,
        product: this.ecomProduct.entity_id
      }], this.ecomProduct.sku)
      if (success) this.$router.push({ path: this.localePath('/checkout/cart/') })
    }
  }
}
